export default {"src":"/_next/static/media/selenium.80aec726.svg","height":269,"width":256,"blurWidth":0,"blurHeight":0};